// extracted by mini-css-extract-plugin
export var actionButton = "_54-1";
export var actionButtons = "_54-2";
export var actions = "_54-0";
export var aiUnread = "_54-10";
export var alignCenter = "_54-h";
export var backWrapper = "_54-3";
export var cellContainer = "_54-4";
export var checkboxContainer = "_54-5";
export var contentContainer = "_54-6";
export var contentHeader = "_54-8";
export var conversationsTableWrapper = "_54-s";
export var draftReplyBadgeContainer = "_54-m";
export var dropdownItem = "_54-b";
export var dropdownItemsContainer = "_54-a";
export var dropdownTitle = "_54-c";
export var errorIcon = "_54-7";
export var filter = "_54-d";
export var gray = "_54-i";
export var headerActionButtons = "_54-e";
export var headerCheckboxContainer = "_54-f";
export var icon = "_54-j";
export var menuContainer = "_54-k";
export var noMoreTicketsIcon = "_54-12";
export var noMoreTicketsSubText = "_54-13";
export var oneLine = "_54-l";
export var optionsButton = "_54-n";
export var plus = "_54-o";
export var portalButtonsWrapper = "_54-g";
export var red = "_54-p";
export var scrolledTop = "_54-9";
export var search = "_54-q";
export var selectedConversationsCount = "_54-r";
export var spinner = "_54-t";
export var strong = "_54-u";
export var summaryCell = "_54-v";
export var tableContainer = "_54-11";
export var tagContainer = "_54-w";
export var threeDots = "_54-x";
export var twoLines = "_54-y";
export var unread = "_54-z";